import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "../lib/anim";
import { EXPERIENCE } from "../data/cv";

export default function Experience() {
  return (
    <section id="experience" className="relative py-16 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
          <motion.p variants={fadeUp} className="font-mono text-xs tracking-[0.22em] uppercase text-neon mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-gradient-to-r from-neon to-transparent" /> 03 — Trajectory
          </motion.p>
          <motion.h2 variants={fadeUp} custom={1} className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Experience &amp; <span className="text-grad">leadership track.</span>
          </motion.h2>
        </motion.div>

        <div className="relative mt-14 pl-6 sm:pl-10" data-testid="experience-timeline">
          <span className="absolute left-0 top-1 bottom-1 w-px bg-gradient-to-b from-neon/60 via-indigo-500/40 to-vio/60" />
          <div className="space-y-12">
            {EXPERIENCE.map((e, i) => (
              <motion.div key={e.role} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={viewportOnce} className="relative" data-testid="timeline-item">
                <span className="absolute -left-6 sm:-left-10 top-2 -translate-x-1/2 grid place-items-center">
                  <span className={`h-3 w-3 rounded-full ${e.current ? "bg-neon shadow-glow-cyan" : "bg-vio/80"} ring-4 ring-ink`} />
                </span>
                <div className="flex flex-wrap items-center gap-3">
                  <span className={`font-mono text-[11px] tracking-[0.15em] uppercase rounded-full px-3 py-1 border ${e.current ? "text-neon border-neon/30 bg-neon/5" : "text-vio border-vio/25 bg-vio/5"}`}>
                    {e.period}
                  </span>
                  {e.current && (
                    <span className="flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider text-emerald-400">
                      <span className="relative flex h-1.5 w-1.5">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
                        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-400" />
                      </span>
                      Current role
                    </span>
                  )}
                </div>
                <h3 className="mt-3 font-display text-lg sm:text-xl font-semibold tracking-tight">{e.role}</h3>
                <p className="mt-1 text-sm text-slate-400">{e.org}</p>
                <ul className="mt-4 space-y-2">
                  {e.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5 text-sm text-slate-400 leading-relaxed max-w-3xl">
                      <span className="mt-1.5 h-1 w-1 rounded-full bg-slate-600 shrink-0" />
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}